<template>
  <div class="radio-list">
    <label v-if="getTitle" class="label">{{ getTitle }}</label>

    <div v-for="(item,index) in values" class="radio" :key="item.value">
      <div :for="sid+index" class="custom-control custom-radio">
        <input
          type="radio"
          class="custom-control-input"
          :class="{'is-invalid': model.$error}"
          :id="sid+index"
          :checked="item.value === model.$model"
          :disabled="disabled"
          :value="item.value"
          @change="onInput($event)"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
          :name="model.$form.testPath ? model.$path : undefined"
        />
        <label class="custom-control-label" :for="sid+index" v-html="item.text"></label>
      </div>
    </div>

    <div v-if="otherLabel">
      <label class="custom-control custom-radio">
        <input
          type="radio"
          class="custom-control-input"
          :class="{'is-invalid': model.$error}"
          :id="sid"
          :checked="otherIsClicked"
          :disabled="disabled"
          @change="onInputOther($event)"
          :name="model.$form.testPath ? model.$path : undefined"
        />
        <label class="custom-control-label" v-show="!otherIsClicked" v-html="otherLabel" :for="sid"></label>
        <input
          class="form-control"
          :class="{'borderless':borderless, 'text-right':model.$schema.type=='number'||model.$schema.type=='money'||model.$schema.type=='integer','is-invalid': model.$error}"
          :name="model.$form.testPath ? model.$path : undefined"
          v-show="otherIsClicked"
          :value="model.$value"
          ref="input"
          :placeholder="otherLabel"
          @input="onInputText"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
        />
      </label>
    </div>

    <w-error :model="model"></w-error>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';

export default {
  name: 'w-radio-list',
  components: {WError},
  mixins: [modelMixin],
  props: {
    values: {
      type: Array,
      default: () => [] // tablice trzeba zwracać przez funkcję
    },
    otherLabel: String,
    inline: Boolean
    // model: Object
  },

  data() {
    return {
      userOther: false,
      sid: 'rlist' + Math.round(Math.random() * 1000000)
    };
  },
  computed: {
    otherIsClicked() {
      if (!this.model.$value) {
        return this.userOther;
      }
      return !this.values.map(x => x.value).includes(this.model.$value);
    }
  },
  created() {
    console.log('creatd', this);
  },
  methods: {
    onInput(evt) {
      this.userOther = false;
      if (evt.target.checked) {
        this.model.$value = evt.target.value;
      }
    },
    onInputOther(evt) {
      console.log('userOther', this);
      this.userOther = true;
      // console.log('onInputOther', this.model.$path);
      this.model.$value = '';
      this.model.$reset();
      setTimeout(() => {
        this.$refs.input.focus();
      }, 10);
    },
    onInputText(evt) {
      console.log('input text', this.model.$path);
      this.userOther = true;

      this.model.$value = evt.target.value;
    },
    onBlur(evt) {
      this.model.$hasFocus = false;
      this.$emit('blur', evt);
    },
    onFocus(evt) {
      this.model.$hasFocus = true;

      this.$emit('focus', evt);
    }
  }
};
</script>

<style>
</style>
